import { IntegrationsPageRoute } from "../integrations";

export enum AppRoute {
    integrations = IntegrationsPageRoute.list
}